const initialProductPrice = $(".current-price").text();
if($("[data-zapp-installation-input]").length) {
    initZappInstallation();
}

function initZappInstallation() {

    //for zapp installation radio btns 
    $("[data-zapp-installation-input]").each(function() {
        $(this).on("click", function () {
            //set to parent the selected variant with its price
            $(this).parent().parent().attr("data-selected", $(this).parent().attr("data-variant"));
            $(this).parent().parent().attr("data-price", $(this).parent().attr("data-price"));

            //disable atc
            $('input[type="submit"]').each(function() {
                $(this).prop('disabled', false);
            });

            updateInstallationPrice(initialProductPrice);
            updatePowerstep();
        })

        function updateInstallationPrice(initialPrice) {
            const installationPrice = $("#installation-product__fieldset").attr("data-price");
            let newPrice = (parseFloat(initialPrice) + parseFloat(installationPrice)) * 100000;
            newPrice = theme.Shopify.formatMoney(newPrice, theme.money_format);

            return $(".current-price").text(newPrice);
        }

        function updatePowerstep() {
            const $powerstepContainer = $("#powerstep-container");
            const $installationProduct = $powerstepContainer.find("[data-installation]");
            const $selectedInstallationVariant = $("#installation-product__fieldset").attr("data-selected");
            let selectedInstallationVariantTitle = '';
            let selectedInstallationVariantPrice = '';

            //get the selected installation
            $("[data-zapp-installation-option]").each(function () {
                if ($selectedInstallationVariant == $(this).attr("data-variant")) {
                    selectedInstallationVariantTitle = $(this).find("label").text();
                    selectedInstallationVariantPrice = $(this).attr("data-price");
                }
            })


            //set in the powerstep the selected installation
            $installationProduct.find("#powerstep__product-variant").text(selectedInstallationVariantTitle);
            $installationProduct.find(".powerstep__product-price").text(theme.Shopify.formatMoney(parseFloat(selectedInstallationVariantPrice) * 100000, theme.money_format));
        }
    });

    document.addEventListener("DOMContentLoaded", () => {

        //disable normal atc event and replace it with ours
        $('input[type="submit"]').each(function () {
            $(this).on("click", (ev) => {
                const selectedId = $("#installation-product__fieldset")?.attr("data-selected");
                if(selectedId) {
                    ev.preventDefault();
                    const atc = async () => {
                        const atcBtn = $('.product-column-right input[type="submit"]');
                        await addInstallationToCart(atcBtn, selectedId);
                    }
                    atc();
                }
            });
        });
    })

    //add installation and product at same time
    async function addInstallationToCart($btn, selectedId) {
        let productForm = $btn.closest("form")[0];

        let formData = {
            'items': [{
                'id': selectedId,
                'quantity': 1
            }, {
                'id': `${$(productForm).attr("data-variant-id")}`,
                'quantity': 1
            }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then((resp) => {
            return resp;
        }).then((data) => {
        })
    }
}


